import React, { useMemo, useEffect, useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import ConfirmBox  from "./ConfirmBox";
import AlertBox from './AlertBox';
import axios from "axios";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
};

const activeStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

const FileUploadView = (props) => {
  const [list, setList] = useState([]);
  const [myFiles, setMyFiles] = useState([]);

  const classes = props.classes || null;
  const id = props.id;
  let deleteUrl = props.deleteUrl || "http://localhost:5000/delete";
  let downloadUrl = props.downloadUrl || "http://localhost:5000/download";
  const listUrl = props.listUrl || "http://localhost:5000/list";
  const uploadUrl = props.uploadUrl || "http://localhost:5000/upload";
  const acceptType = props.acceptType || "image/*, audio/*, .pdf";

  deleteUrl = deleteUrl.endsWith("/") ? deleteUrl : deleteUrl + "/";
  downloadUrl = downloadUrl.endsWith("/") ? downloadUrl : downloadUrl + "/";

  async function fetchData() {
    try {
      //console.log('listUrl:'+ listUrl)
      const response = await axios.get(listUrl);
      setList(response.data);
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);
  const onDrop = useCallback(
    (acceptedFiles) => {
      setMyFiles([...myFiles, ...acceptedFiles]);
    },
    [myFiles]
  );

  

  const downloadFile = (e, file) => {
    let fullUrl = downloadUrl.replace(/.$/, '~') + btoa(file);
    console.log('Full download url:' + fullUrl)
    window.open(fullUrl, "_blank");
  };

  const files = myFiles.map((file) => (
    <div key={file} style={{ width: "80%", textAlign: "left" }}>
      {file.path}
    </div>
  ));

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    accept: acceptType,
    multiple: true,
  });

  

  return (
    <div className="container">
      
  
      <div style={{ width: "80%", textAlign: "left" }}>
        <h4>Uploaded Files</h4>
        <ul>
          {list.map((file, i) => {
            return (
              <div key={file}>
                <p key={i}>
                  <button
                    className={classes ? classes.downloadButton : ""}
                    onClick={(e) => {
                      downloadFile(e, file);
                    }}
                  >
                    ↓
                  </button>{" "}
                 
                  <span key={i}>{file}</span>
                </p>
              </div>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default FileUploadView;